<template>
  <v-card
    class="postContent"
    v-if="!isObjectEmpty(item)"
  >
    <template v-if="item.type === 'cardInfo'">
      <CardInfo :text="item.text" />
    </template>
    <template v-else>
      <div>
        <PostHeaderMedia
          class="postHeaderMedia"
          v-if="isMedia"
          :item="item"
        />
        <PostHeader
          v-else
          :item="item"
          @delete="onDeletePost"
        />

        <!-- panel body -->
        <PostContent v-if="item.content" :content="item.content" />
        <slot></slot>

        <PostMedia
          v-if="!isMedia"
          :mediaList="item.media"
          :parent="{ type: 'post', id: item.id }"
        />

        <PostFooter
          class="postFooter"
          ref="PostFooter"
          :totalComment="item.totalComment"
          :totalLike="item.totalLike"
          :isLiked="item.isLiked"
          :entityId="item.id"
          :entityName="(isMedia && !item.isOneMedia) ? 'media' : 'post'"
          @onLikePost="onLikePost"
        />

        <v-divider v-if="isMedia" class="my-6"></v-divider>
      </div>
      <!-- list comment -->
      <div class="commentsWrap">
        <PostComments
          v-if="reInit"
          :entityId="item.id"
          :entityName="(isMedia && !item.isOneMedia) ? 'media' : 'post'"
          :items="item.comments"
          :totalParentComment="item.totalParentComment"
        />
      </div>
    </template>
  </v-card>
</template>
<script>
import PostHeader from "@/components/Post/PostHeader";
import PostHeaderMedia from "@/components/Post/PostHeaderMedia";
import PostComments from "@/components/Post/PostComments/Main";
import PostFooter from "@/components/Post/PostFooter";
import PostMedia from "@/components/Post/PostMedia";
import CommentInput from "@/components/Forms/CommentInput";
import PostContent from "@/components/Post/PostContent";
import CardInfo from "@/components/Card/CardInfo";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isMedia: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    PostHeader,
    PostHeaderMedia,
    PostComments,
    PostFooter,
    CommentInput,
    PostMedia,
    PostContent,
    CardInfo,
  },
  provide: function () {
    return {
      getPost: this.getPost,
      setPost: this.setPost,
    };
  },
  data() {
    return {
      reInit: true,
      post: {},
    };
  },
  computed: {
    medias() {
      let vm = this;
      let photos = vm.item.photos || [];
      let videos = vm.item.videos || [];
      let arr = [...photos, ...videos];
      return arr;
    }
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler(val) {
        this.post = val;
      },
    },
  },
  methods: {
    getPost() {
      return this.post;
    },
    setPost(v) {
      this.$emit("onData", { ...v, mode: "update" });
    },
    refreshComment() {
      this.reInit = false;
      this.$nextTick(() => {
        this.reInit = true;
      });
    },
    onDeletePost(id) {
      this.$emit("onData", { id: id, mode: "delete" });
      this.$store.dispatch("setTotalPost", -1); //set +/- posts of user
    },
    onLikePost(item) {
      this.$emit("onData", { ...item, mode: "update" });
    },
  },
};
</script>
